// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

export default {
  isProd: import.meta.env.PROD,
  isDev: import.meta.env.DEV,
  isStaging: import.meta.env.MODE === 'staging',
  mode: import.meta.env.MODE as 'production' | 'development' | 'staging',
  apiBaseUrl: import.meta.env.VITE_BASE_API_URL,
  receiptS3Bucket: import.meta.env.VITE_RECEIPT_S3_BUCKET,
}
